/**
 * MessQrCard — parent / admin downloads a printable QR for a student.
 * The QR encodes a signed payload the warden scans on `/app/mess-scan`.
 */
import React, { useState } from "react";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { QrCode, DownloadSimple } from "@phosphor-icons/react";
import axios from "axios";
import { toast } from "sonner";

export function MessQrCard({ studentId, studentName }) {
  const [open, setOpen] = useState(false);
  const [src, setSrc] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try {
      const r = await axios.get(`${API}/mess/attendance/qr-card/${studentId}.png`, {
        responseType: "blob", withCredentials: true,
      });
      setSrc(URL.createObjectURL(r.data));
      setOpen(true);
    } catch (e) {
      toast.error(e?.response?.data?.detail || e.message);
    } finally { setBusy(false); }
  };

  const download = () => {
    if (!src) return;
    const a = document.createElement("a");
    a.href = src;
    a.download = `mess-qr-${studentName?.replace(/\s+/g, "_") || studentId}.png`;
    a.click();
  };

  return (
    <>
      <Button size="sm" variant="outline" onClick={load} disabled={busy} data-testid={`mess-qr-btn-${studentId}`}>
        <QrCode size={14} className="mr-1.5" /> {busy ? "Loading…" : "Mess QR card"}
      </Button>
      {open && src && (
        <div className="fixed inset-0 z-50 grid place-items-center bg-black/60 p-4" onClick={() => setOpen(false)}>
          <div className="bg-white rounded-lg p-5 max-w-sm" onClick={(e) => e.stopPropagation()} data-testid={`mess-qr-dialog-${studentId}`}>
            <div className="font-medium text-center mb-1">{studentName}</div>
            <div className="text-xs text-[var(--vs-text-secondary)] text-center mb-3">Show this to the mess warden at every meal.</div>
            <img src={src} alt="QR" className="w-full max-w-[280px] mx-auto" />
            <div className="flex justify-center gap-2 mt-3">
              <Button variant="outline" onClick={() => setOpen(false)}>Close</Button>
              <Button data-testid={`mess-qr-download-${studentId}`} onClick={download}><DownloadSimple size={14} className="mr-1.5" /> Download PNG</Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
